import { useState } from "react";
import Navbar from "./components/Navbar";
import IntroAnimation from "./components/IntroAnimation";
import ConferenceOverview from "./components/ConferenceOverview";
import Introduction1 from "./components/Introduction1";
import Introduction2 from "./components/Introduction2";
import Highlights from "./components/Highlights";
import GetTicket from "./components/GetTicket";
import Sponsors from "./components/Sponsors";
import Footer from "./components/Footer";
import Modal from "./components/Modal"
import MobileMenu from "./components/MobileMenu";

function App() {
  return (
    <div className="w-full bg-black-900">
      <IntroAnimation />
    </div>
  );
}

export default App;
